import { useRef, useState } from 'react';
import { calmTokens as t } from '../../../shared/tokens';
import { IconFile, IconUpload } from '../../../shared/icons';

/**
 * Zone de dépôt d'un export CSV (glisser-déposer ou clic).
 * onFile(file) est appelé dès qu'un fichier .csv est choisi.
 */
export default function CsvDropZone({ onFile, disabled, busy, file, title, hint }) {
  const inputRef = useRef(null);
  const [over, setOver] = useState(false);

  const pick = (f) => {
    if (!f || disabled) return;
    if (!/\.csv$/i.test(f.name)) return;
    onFile(f);
  };

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={() => !disabled && inputRef.current?.click()}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          inputRef.current?.click();
        }
      }}
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        pick(e.dataTransfer?.files?.[0]);
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '16px 18px',
        background: over ? t.surface2 : t.bg,
        border: `1px dashed ${over ? t.accent : t.borderS}`,
        borderRadius: 14,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        transition: 'background .15s, border-color .15s',
        color: t.text,
        fontFamily: t.fontUi,
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".csv,text/csv"
        style={{ display: 'none' }}
        onChange={(e) => {
          pick(e.target.files?.[0]);
          e.target.value = '';
        }}
      />
      <span
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: t.accentDim,
          color: t.accent,
          display: 'grid',
          placeItems: 'center',
          flexShrink: 0,
        }}
      >
        {file ? <IconFile size={16} /> : <IconUpload size={16} />}
      </span>
      <span style={{ minWidth: 0, flex: 1 }}>
        <span
          style={{
            display: 'block',
            fontSize: 13,
            fontWeight: 500,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {busy ? 'Analyse en cours…' : file ? file.name : title || 'Déposer un export CSV Caisse d\'Épargne'}
        </span>
        <span style={{ display: 'block', fontSize: 11, color: t.textMute, marginTop: 2 }}>
          {file && !busy
            ? `${Math.round(file.size / 1024)} Ko · cliquer pour changer de fichier`
            : hint || 'Glisser-déposer ou cliquer · 2 Mo max'}
        </span>
      </span>
    </div>
  );
}
